/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStarEmpty: {
  name: 'star-empty';
  data: string;
} = {
  name: 'star-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .437.257l2.375 4.275 4.243.471a.5.5 0 0 1 .299.85l-3.311 3.311.947 4.738a.5.5 0 0 1-.733.535L8 12.572l-4.257 2.365a.5.5 0 0 1-.733-.535l.947-4.738-3.31-3.31a.5.5 0 0 1 .298-.85l4.243-.472L7.563.757A.5.5 0 0 1 8 .5Zm0 1.53L5.937 5.743a.5.5 0 0 1-.382.254l-3.466.385 2.765 2.764a.5.5 0 0 1 .136.452l-.788 3.94 3.555-1.975a.5.5 0 0 1 .486 0l3.555 1.975-.788-3.94a.5.5 0 0 1 .136-.452l2.765-2.764-3.466-.385a.5.5 0 0 1-.382-.254L8 2.03Z" fill="currentColor"/></svg>`,
};
